(function () {
  'use strict';

  function initBuildRoutine(section) {
    var sid = section.id.replace('sbr-', '');
    var configKey = 'SBR_CONFIG_' + sid.replace(/-/g, '_');
    var config = window[configKey];
    if (!config) return;

    var mobileLayout = section.dataset.mobileLayout || 'grid';
    var STORAGE_KEY = 'sbr_state_' + sid;

    // ---- DOM refs ----
    var stepEls        = Array.prototype.slice.call(section.querySelectorAll('.sbr__step'));
    var slotsEl        = section.querySelector('.sbr__slots');
    var priceWrapEl    = section.querySelector('.sbr__price-wrap');
    var panelAtcBtn    = section.querySelector('.sbr__panel-inner .sbr__atc-btn');
    var subtotalValEl  = section.querySelector('.sbr__subtotal-val');
    var savingsValEl   = section.querySelector('.sbr__savings-val');
    var totalValEl     = section.querySelector('.sbr__total-val');
    var panelCountEl   = section.querySelector('.sbr__panel-count');
    var mobileBar      = section.querySelector('.sbr__mobile-bar');
    var mobileAtcBtn   = mobileBar ? mobileBar.querySelector('.sbr__atc-btn') : null;
    var progressFillEl = section.querySelector('[data-progress-fill]');
    var progressLabelEl= section.querySelector('[data-progress-label]');

    // ---- State: { stepId: [{ variantId, price, comparePrice, title, img }] } ----
    var state = {};
    stepEls.forEach(function (s) { state[s.dataset.stepId] = []; });

    // ---- Money formatter ----
    function money(cents) {
      var amount = Math.round(cents / 100);
      return 'Rs. ' + amount.toLocaleString('en-PK');
    }

    // ================================================================
    // LOCALSTORAGE — PERSIST STATE
    // ================================================================
    function saveState() {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    }

    function loadState() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var saved = JSON.parse(raw);
        // Only restore keys that still exist as steps on this page
        Object.keys(saved).forEach(function (stepId) {
          if (state.hasOwnProperty(stepId)) {
            state[stepId] = saved[stepId] || [];
          }
        });
      } catch (e) {}
    }

    // ================================================================
    // ACCORDION
    // ================================================================
    function openStep(stepEl) {
      var body   = stepEl.querySelector('.sbr__step-body');
      var header = stepEl.querySelector('.sbr__step-header');
      stepEl.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      body.classList.remove('sbr__step-body--closed');
      refreshStepNum(stepEl);
    }

    function closeStep(stepEl) {
      var body   = stepEl.querySelector('.sbr__step-body');
      var header = stepEl.querySelector('.sbr__step-header');
      stepEl.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
      body.classList.add('sbr__step-body--closed');
      refreshStepNum(stepEl);
    }

    function refreshStepNum(stepEl) {
      var numEl   = stepEl.querySelector('.sbr__step-num');
      var stepId  = stepEl.dataset.stepId;
      var isDone  = (state[stepId] || []).length > 0;
      var isOpen  = stepEl.classList.contains('is-open');
      numEl.classList.toggle('is-done',   isDone);
      numEl.classList.toggle('is-active', !isDone && isOpen);
      numEl.textContent = isDone ? '✓' : stepEl.dataset.stepIndex;
    }

    stepEls.forEach(function (stepEl) {
      var header = stepEl.querySelector('.sbr__step-header');
      header.addEventListener('click', function () {
        var isOpen = stepEl.classList.contains('is-open');
        stepEls.forEach(closeStep);
        if (!isOpen) openStep(stepEl);
      });
    });

    // ================================================================
    // SLICK SLIDER (per step)
    // ================================================================
    function initStepSlider(stepEl) {
      var wrap   = stepEl.querySelector('.sbr__slider-wrap');
      if (!wrap) return;
      var slider = wrap.querySelector('.sbr__cards--slider');
      if (!slider || slider.classList.contains('slick-initialized')) return;

      var perRow        = parseInt(wrap.dataset.perRow)        || 3;
      var perRowTablet  = parseInt(wrap.dataset.perRowTablet)  || 3;
      var perRowMobile  = Math.max(1, parseInt(wrap.dataset.perRowMobile) || 2);
      var showArrows    = wrap.dataset.showArrows !== 'false';
      var showDots      = wrap.dataset.showDots   !== 'false';
      var arrowSize     = config.arrowSize || 36;

      var arrowSvg  = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,18 15,12 9,6"/></svg>';
      var prevArrow = '<button type="button" class="slick-prev slick-arrow" aria-label="Previous" style="width:' + arrowSize + 'px;height:' + arrowSize + 'px;">' + arrowSvg + '</button>';
      var nextArrow = '<button type="button" class="slick-next slick-arrow" aria-label="Next"     style="width:' + arrowSize + 'px;height:' + arrowSize + 'px;">' + arrowSvg + '</button>';

      // Grid mode: skip Slick on mobile — CSS grid handles it
      if (window.innerWidth < 750 && mobileLayout !== 'slider') return;

      var responsive = [
        { breakpoint: 1025, settings: { slidesToShow: perRowTablet } }
      ];
      if (mobileLayout === 'slider') {
        responsive.push({ breakpoint: 750, settings: { slidesToShow: perRowMobile } });
      }

      $(slider).slick({
        slidesToShow   : perRow,
        slidesToScroll : 1,
        arrows         : showArrows,
        dots           : showDots,
        infinite       : false,
        prevArrow      : prevArrow,
        nextArrow      : nextArrow,
        responsive     : responsive
      });

      $(slider).slick('setPosition');

      // Arrow colors
      var arrowBg         = config.arrowBg         || '#ffffff';
      var arrowColor      = config.arrowColor       || '#0a0a0a';
      var arrowBgHover    = config.arrowBgHover     || '#0a0a0a';
      var arrowColorHover = config.arrowColorHover  || '#ffffff';

      wrap.querySelectorAll('.slick-arrow').forEach(function (btn) {
        btn.style.background = arrowBg;
        btn.style.color      = arrowColor;
        btn.addEventListener('mouseenter', function () {
          btn.style.background = arrowBgHover;
          btn.style.color      = arrowColorHover;
          btn.style.borderColor= arrowBgHover;
        });
        btn.addEventListener('mouseleave', function () {
          btn.style.background = arrowBg;
          btn.style.color      = arrowColor;
          btn.style.borderColor= '#e0e0e0';
        });
      });

      // Dots — colors handled via CSS variables, JS only needed for pill width reset on slide change
      function styleDots() {
        var ul = wrap.querySelector('.slick-dots');
        if (!ul) return;
        // Reset all inactive dots to base size (CSS var handles colors)
        ul.querySelectorAll('li:not(.slick-active) button').forEach(function (btn) {
          btn.style.width = '';
        });
      }

      $(slider).on('afterChange init', styleDots);
      setTimeout(styleDots, 150);
    }

    // ================================================================
    // CARD SELECTION
    // ================================================================
    section.addEventListener('click', function (e) {
      var card = e.target.closest('.sbr__card');
      if (!card) return;
      if (card.dataset.soldOut === 'true') return;

      var stepId  = card.dataset.stepId;
      var stepEl  = section.querySelector('.sbr__step[data-step-id="' + stepId + '"]');
      var selMode = stepEl ? stepEl.dataset.selection : 'single';

      var variantId    = card.dataset.variantId;
      var price        = parseInt(card.dataset.price)        || 0;
      var comparePrice = parseInt(card.dataset.comparePrice) || 0;
      var title        = card.dataset.title;
      var img          = card.dataset.img;

      var existing   = state[stepId] || [];
      var isSelected = existing.some(function (i) { return i.variantId === variantId; });

      if (selMode === 'single') {
        state[stepId] = isSelected
          ? []
          : [{ variantId: variantId, price: price, comparePrice: comparePrice, title: title, img: img }];
      } else {
        state[stepId] = isSelected
          ? existing.filter(function (i) { return i.variantId !== variantId; })
          : existing.concat([{ variantId: variantId, price: price, comparePrice: comparePrice, title: title, img: img }]);
      }

      saveState();
      updateStepUI(stepEl, stepId);
      updatePanel();

      // Auto-advance to next incomplete step (single-select only)
      if (selMode === 'single' && !isSelected) {
        var nextStep = findNextIncompleteStep(stepEl);
        if (nextStep) {
          setTimeout(function () {
            stepEls.forEach(closeStep);
            openStep(nextStep);
            nextStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 300);
        }
      }
    });

    function findNextIncompleteStep(currentStepEl) {
      var idx = stepEls.indexOf(currentStepEl);
      for (var i = idx + 1; i < stepEls.length; i++) {
        var sid2 = stepEls[i].dataset.stepId;
        if ((state[sid2] || []).length === 0) return stepEls[i];
      }
      return null;
    }

    // ================================================================
    // REMOVE from slot (delegated — slots are rebuilt dynamically)
    // ================================================================
    if (slotsEl) {
      slotsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.sbr__slot-remove');
        if (!btn) return;
        var row       = btn.closest('[data-step-id]');
        var stepId    = row ? row.dataset.stepId : null;
        var variantId = row ? row.dataset.variantId : null;
        if (!stepId) return;

        if (variantId) {
          state[stepId] = (state[stepId] || []).filter(function (i) { return i.variantId !== variantId; });
        } else {
          state[stepId] = [];
        }

        saveState();
        var stepEl = section.querySelector('.sbr__step[data-step-id="' + stepId + '"]');
        updateStepUI(stepEl, stepId);
        updatePanel();
      });
    }

    // ================================================================
    // UPDATE UI
    // ================================================================
    function updateStepUI(stepEl, stepId) {
      if (!stepEl) return;
      var items  = state[stepId] || [];
      var isDone = items.length > 0;

      // Card selected states
      stepEl.querySelectorAll('.sbr__card').forEach(function (card) {
        var vid = card.dataset.variantId;
        var sel = items.some(function (i) { return i.variantId === vid; });
        card.classList.toggle('is-selected', sel);
        var btn = card.querySelector('.sbr__add-btn');
        if (btn && card.dataset.soldOut !== 'true') {
          btn.textContent = sel ? config.addedBtnText : config.addBtnText;
        }
      });

      stepEl.classList.toggle('is-done', isDone);
      refreshStepNum(stepEl);

      // Collapsed label
      var label = stepEl.querySelector('.sbr__step-selected-label');
      if (label) {
        if (items.length === 1)      label.textContent = items[0].title;
        else if (items.length > 1)   label.textContent = items.length + ' selected';
        else                         label.textContent = '';
      }

      // Subtitle
      var sub = stepEl.querySelector('.sbr__step-sub');
      if (sub) {
        if (isDone && items.length === 1)      sub.textContent = items[0].title;
        else if (isDone && items.length > 1)   sub.textContent = items.length + ' products selected';
        else                                   sub.textContent = stepEl.dataset.subtitle || '';
      }
    }

    function updatePanel() {
      var totalRequired     = 0;
      var completedRequired = 0;
      var subtotal          = 0;

      stepEls.forEach(function (stepEl) {
        var stepId   = stepEl.dataset.stepId;
        var required = stepEl.dataset.required === 'true';
        var items    = state[stepId] || [];
        if (required) {
          totalRequired++;
          if (items.length > 0) completedRequired++;
        }
        items.forEach(function (item) { subtotal += item.price; });
      });

      var allDone  = completedRequired >= totalRequired;
      var discount = config.discountPercent || 0;
      var savings  = Math.round(subtotal * discount / 100);
      var total    = subtotal - savings;

      var countText = completedRequired + '/' + totalRequired;
      if (panelCountEl) panelCountEl.textContent = countText + ' steps complete';

      // Progress bar
      var pct = totalRequired > 0 ? Math.round(completedRequired / totalRequired * 100) : 0;
      if (progressFillEl)  progressFillEl.style.width = pct + '%';
      if (progressLabelEl) progressLabelEl.textContent = countText;

      // Mobile step dots
      if (mobileBar) {
        stepEls.forEach(function (stepEl) {
          var dot = mobileBar.querySelector('.sbr__mbar-step[data-step-id="' + stepEl.dataset.stepId + '"]');
          if (dot) dot.classList.toggle('is-done', (state[stepEl.dataset.stepId] || []).length > 0);
        });
      }

      if (priceWrapEl)   priceWrapEl.style.display = subtotal > 0 ? '' : 'none';
      if (subtotalValEl) subtotalValEl.textContent = money(subtotal);
      if (savingsValEl)  savingsValEl.textContent  = '− ' + money(savings);
      if (totalValEl)    totalValEl.textContent    = money(total);

      updateSlots();

      var btnText = allDone
        ? config.completeBtnText
        : (config.incompleteBtnText || 'Add Bundle to Cart')
            .replace('X', completedRequired)
            .replace('N', totalRequired);

      if (panelAtcBtn) {
        panelAtcBtn.disabled    = !allDone;
        panelAtcBtn.textContent = btnText;
      }
      if (mobileAtcBtn) {
        mobileAtcBtn.disabled    = !allDone;
        mobileAtcBtn.textContent = 'Add to Cart - ' + money(total);
      }
    }

    // ================================================================
    // SLOTS — rebuilt dynamically so multi-select shows all products
    // ================================================================
    function getStepMeta(stepId) {
      var stepEl = section.querySelector('.sbr__step[data-step-id="' + stepId + '"]');
      if (!stepEl) return { title: '', sub: '' };
      var titleEl = stepEl.querySelector('.sbr__step-title');
      return {
        title: titleEl ? titleEl.textContent.trim() : '',
        sub  : stepEl.dataset.subtitle || ''
      };
    }

    function updateSlots() {
      if (!slotsEl) return;

      var html = '';

      stepEls.forEach(function (stepEl) {
        var stepId = stepEl.dataset.stepId;
        var items  = state[stepId] || [];
        var meta   = getStepMeta(stepId);

        html += '<div class="sbr__slot-group">';

        // Category header
        html += '<div class="sbr__slot-group-hd">'
              + '<strong class="sbr__slot-group-title">' + meta.title + '</strong>'
              + (meta.sub ? '<span class="sbr__slot-group-sub">' + meta.sub + '</span>' : '')
              + '</div>';

        if (items.length === 0) {
          html += '<div class="sbr__slot sbr__slot--empty" data-step-id="' + stepId + '">'
                + '<span class="sbr__slot-empty-txt">' + (config.lblEmpty || 'Make your selection') + '</span>'
                + '</div>';
        } else {
          items.forEach(function (item) {
            html += '<div class="sbr__slot is-filled" data-step-id="' + stepId + '" data-variant-id="' + item.variantId + '">'
                  + '<button class="sbr__slot-remove" type="button" aria-label="Remove">×</button>'
                  + '<div class="sbr__slot-icon">'
                  + (item.img ? '<img src="' + item.img + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '')
                  + '</div>'
                  + '<span class="sbr__slot-name">' + item.title + '</span>'
                  + '</div>';
          });
        }

        html += '</div>'; // .sbr__slot-group
      });

      slotsEl.innerHTML = html;
    }

    // ================================================================
    // ADD TO CART → redirect to /cart
    // ================================================================
    function handleATC() {
      var items = [];
      stepEls.forEach(function (stepEl) {
        var stepId = stepEl.dataset.stepId;
        (state[stepId] || []).forEach(function (item) {
          items.push({
            id         : parseInt(item.variantId),
            quantity   : 1,
            properties : { '_routine': 'Build Your Routine' }
          });
        });
      });
      if (items.length === 0) return;

      var btns = [panelAtcBtn, mobileAtcBtn].filter(Boolean);
      btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });

      fetch('/cart/add.js', {
        method  : 'POST',
        headers : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body    : JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        // Clear saved state so next visit starts fresh
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        // Redirect — apply discount code if set, else go straight to cart
        var code = config.discountCode;
        window.location.href = (code && code.trim())
          ? '/discount/' + encodeURIComponent(code.trim()) + '?redirect=/cart'
          : '/cart';
      })
      .catch(function () {
        btns.forEach(function (b) { b.textContent = 'Error — try again'; });
        setTimeout(function () {
          btns.forEach(function (b) { b.disabled = false; b.textContent = config.completeBtnText || 'Add Bundle to Cart'; });
        }, 2500);
      });
    }

    if (panelAtcBtn)  panelAtcBtn.addEventListener('click',  handleATC);
    if (mobileAtcBtn) mobileAtcBtn.addEventListener('click', handleATC);

    // ================================================================
    // BOOT — restore state then render
    // ================================================================
    loadState();

    // Restore UI for all steps from saved state
    stepEls.forEach(function (stepEl) {
      updateStepUI(stepEl, stepEl.dataset.stepId);
    });
    updatePanel();

    // Open first incomplete step
    var firstIncomplete = null;
    for (var i = 0; i < stepEls.length; i++) {
      if ((state[stepEls[i].dataset.stepId] || []).length === 0) {
        firstIncomplete = stepEls[i];
        break;
      }
    }
    openStep(firstIncomplete || stepEls[0]);

    // Init ALL sliders (height:0 not display:none so slick gets real width)
    setTimeout(function () {
      stepEls.forEach(function (s) { initStepSlider(s); });
    }, 80);
  }

  // ---- Boot ----
  function boot() {
    document.querySelectorAll('.sbr__section').forEach(function (section) {
      if (!section.dataset.sbrInit) {
        section.dataset.sbrInit = '1';
        initBuildRoutine(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
